<div class="controls-holder">
	<div class="left-side">
		<qo-toggle-box
			[attr.data-cy]="'view-type-toggle'"
			[isLeftActive]="(viewType$ | async) === VIEW_TYPE.PERSON_VIEW"
			(leftClicked)="setViewType(VIEW_TYPE.PERSON_VIEW)"
			(rightClicked)="setViewType(VIEW_TYPE.GROUP_VIEW)"
			leftText="{{ 'SCHEDULE.PERSONS' | translate }}"
			rightText="{{ 'SCHEDULE.GROUPS' | translate }}"
		>
		</qo-toggle-box>
		<qo-toggle-box
			[attr.data-cy]="'period-toggle'"
			*ngIf="(user$ | async).isAdmin()"
			[isLeftActive]="(periodType$ | async) === PERIOD_TYPE.ONE_WEEK"
			(leftClicked)="setPeriodType(PERIOD_TYPE.ONE_WEEK)"
			(rightClicked)="setPeriodType(PERIOD_TYPE.TWO_WEEKS)"
			leftText="{{ 'SCHEDULE.1_WEEK' | translate }}"
			rightText="{{ 'SCHEDULE.2_WEEKS' | translate }}"
		>
		</qo-toggle-box>
	</div>
	<div class="center">
		<div class="back qo-secondary-invert" (click)="lastPeriod()">
			<qo-icon [icon]="EQORebrandIcon.arrow_left_dark" [size]="'sm'" [color]="EQORebrandColor.SECONDARY"></qo-icon>
		</div>
		<div class="period-holder" (click)="picker.open()" *ngIf="(selectedDates$ | async)[0]">
			<div class="week-number">{{firstDate | smLocalDate:'w'}}</div>
			<div class="date-range">
				{{firstDate | smLocalDate:'d MMM'}} - {{lastDate | smLocalDate:'d MMM'}}
			</div>
			<input
				matInput
				[matDatepicker]="picker"
				[value]="(selectedDates$ | async)[0].toDate()"
				(dateChange)="goToDate($event.value)">
			<mat-datepicker
				#picker
			></mat-datepicker>
		</div>
		<div class="forward qo-secondary-invert" (click)="nextPeriod()">
			<qo-icon [icon]="EQORebrandIcon.arrow_right_dark" [size]="'sm'" [color]="EQORebrandColor.SECONDARY"></qo-icon>
		</div>
	</div>
	<div class="right-side">
		<qo-toggle-box
			*ngIf="!(user$ | async).isAdmin()"
			[isLeftActive]="(periodType$ | async) === PERIOD_TYPE.ONE_WEEK"
			(leftClicked)="setPeriodType(PERIOD_TYPE.ONE_WEEK)"
			(rightClicked)="setPeriodType(PERIOD_TYPE.TWO_WEEKS)"
			leftText="{{ 'SCHEDULE.1_WEEK' | translate }}"
			rightText="{{ 'SCHEDULE.2_WEEKS' | translate }}"
		>
		</qo-toggle-box>
		<qo-select-dropdown
			*ngIf="(user$ | async).isAdmin()"
			text="{{'SCHEDULE.TOOLS' | translate}}"
			[actions]="toolActions"
			[shadow]="SHADOWS.MEDIUM"
		></qo-select-dropdown>
		<qo-select-dropdown
			*ngIf="(user$ | async).isAdmin()"
			text="{{'SCHEDULE.SHIFT_TEMPLATES' | translate}}"
			[actions]="templateActions"
			[shadow]="SHADOWS.MEDIUM"
		></qo-select-dropdown>
	</div>
</div>
